import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@copro/api";
import { useSpace } from "../../../hooks/useSpace";
import { PrivateNotesDatabase } from "../../../types";
import { getNextPageIndex, pageRange } from "../../../utils/pagination";
import { keys } from "./keys";

const PAGE_SIZE = 12;

async function fetchPrivateNotes(spaceId: string, pageIndex: number): Promise<PrivateNotesDatabase[]> {
  const { from, to } = pageRange(pageIndex, PAGE_SIZE);

  const { data, error } = await apiClient
    .from('private_notes')
    .select('*')
    .eq('space_id', spaceId)
    .order('inserted_at', { ascending: false })
    .order('id', { ascending: false })
    .range(from, to);

  if (error) {
    throw error;
  }

  return data ?? [];
}

export function useGetPrivateNotes() {
  const { currentSpace } = useSpace();

  return useInfiniteQuery({
    queryKey: keys.list(currentSpace?.id ?? ''),
    queryFn: ({ pageParam }) => fetchPrivateNotes(currentSpace!.id, pageParam),
    initialPageParam: 0,
    getNextPageParam: getNextPageIndex(PAGE_SIZE),
    enabled: !!currentSpace?.id,
  });
}
